export default __webpack_public_path__ + "static/media/Hon Lien.d1c12e2c.jpg";